document.addEventListener("DOMContentLoaded", initTipPage)
document.addEventListener("turbolinks:load", initTipPage)

function initTipPage() {
  const MESSAGE_CHARACTER_LIMITS = [
    { amount: 5, limit: 100 },
    { amount: 10, limit: 250 },
    { amount: 15, limit: 350 },
    { amount: 20, limit: 500 }
  ]

  const form = document.getElementById("tip-form")
  if (!form || form.dataset.tipPageInitialized === "true") return
  form.dataset.tipPageInitialized = "true"

  const isSuperAdminPreview = form.dataset.superAdminPreview === "true"
  const stripeKey = form.dataset.stripeKey
  const stripe = isSuperAdminPreview ? null : Stripe(stripeKey)

  let elements = null
  let currentAmount = 500 // default $5 in cents
  const messageArea = document.getElementById("tip-message")
  const charCount = document.getElementById("char-count")
  const errorsDiv = document.getElementById("payment-errors")

  function messageLimitForAmount(amountDollars) {
    for (const tier of MESSAGE_CHARACTER_LIMITS) {
      if (amountDollars <= tier.amount) return tier.limit
    }

    return MESSAGE_CHARACTER_LIMITS[MESSAGE_CHARACTER_LIMITS.length - 1].limit
  }

  function updateMessageLimit() {
    if (!messageArea || !charCount) return

    const dollars = parseFloat(document.getElementById("tip-amount").value) || 0
    const limit = messageLimitForAmount(dollars)
    messageArea.maxLength = limit
    if (messageArea.value.length > limit) {
      messageArea.value = messageArea.value.slice(0, limit)
    }
    charCount.textContent = `${messageArea.value.length} / ${limit} characters`
  }

  function resetPresetButtons() {
    document.querySelectorAll(".amount-preset").forEach(button => {
      button.classList.remove("btn-secondary")
      button.classList.add("btn-outline-secondary")
    })
  }

  function mountPaymentElement(amountCents) {
    if (isSuperAdminPreview) return

    const container = document.getElementById("payment-element")
    if (!container) return

    container.innerHTML = ""

    elements = stripe.elements({
      mode: "payment",
      amount: amountCents,
      currency: "usd",
      appearance: {
        theme: "night",
        variables: { colorPrimary: "#e94560" }
      }
    })

    const paymentEl = elements.create("payment")
    paymentEl.mount("#payment-element")
  }

  // --- Amount preset buttons ---
  document.querySelectorAll(".amount-preset").forEach(btn => {
    btn.addEventListener("click", () => {
      resetPresetButtons()
      btn.classList.remove("btn-outline-secondary")
      btn.classList.add("btn-secondary")
      const dollars = parseInt(btn.dataset.amount)
      currentAmount = dollars * 100
      document.getElementById("tip-amount").value = dollars
      updateMessageLimit()
      mountPaymentElement(currentAmount)
    })
  })

  document.getElementById("tip-amount").addEventListener("change", e => {
    const dollars = parseFloat(e.target.value) || 0
    if (dollars >= 5) {
      currentAmount = Math.round(dollars * 100)
      resetPresetButtons()
      updateMessageLimit()
      mountPaymentElement(currentAmount)
    }
  })

  // --- Character counter ---
  if (messageArea && charCount) {
    messageArea.addEventListener("input", () => {
      updateMessageLimit()
    })
  }

  // --- Initial mount ---
  updateMessageLimit()
  mountPaymentElement(currentAmount)

  // --- Form submit ---
  form.addEventListener("submit", async e => {
    e.preventDefault()
    const submitBtn = document.getElementById("submit-tip")
    const statusDiv = document.getElementById("tip-status")

     if (submitBtn.disabled) return

    const tipperName = (document.getElementById("tipper-name") || document.querySelector("input[name='tip[tipper_name]']"))?.value?.trim()
    if (!tipperName) {
      errorsDiv.textContent = "Please enter your name."
      return
    }

    const dollarInput = document.getElementById("tip-amount").value
    const dollars = parseFloat(dollarInput) || 0
    if (dollars < 5) {
      errorsDiv.textContent = "Minimum tip is $5.00."
      updateMessageLimit()
      submitBtn.disabled = false
      submitBtn.textContent = isSuperAdminPreview ? "Send Test Tip" : "Send Tip"
      return
    }
    currentAmount = Math.round(dollars * 100)
    const messageLimit = messageLimitForAmount(dollars)
    const messageValue = document.getElementById("tip-message").value.trim()
    if (messageValue.length > messageLimit) {
      errorsDiv.textContent = `Message must be ${messageLimit} characters or fewer for this tip amount.`
      updateMessageLimit()
      submitBtn.disabled = false
      submitBtn.textContent = isSuperAdminPreview ? "Send Test Tip" : "Send Tip"
      return
    }

    submitBtn.disabled = true
    submitBtn.textContent = "Processing..."
    errorsDiv.textContent = ""

    const csrfToken = document.querySelector("meta[name='csrf-token']")?.content

    const res = await fetch("/tips", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken || ""
      },
      body: JSON.stringify({
        tip: {
          tipper_name: tipperName,
          tipper_email: (document.getElementById("tipper-email") || document.querySelector("input[name='tip[tipper_email]']"))?.value?.trim(),
          amount_cents: currentAmount,
          message: messageValue
        }
      })
    })

    const data = await res.json()
    if (!res.ok || data.error) {
      errorsDiv.textContent = data.error || "Something went wrong. Please try again."
      submitBtn.disabled = false
      submitBtn.textContent = isSuperAdminPreview ? "Send Test Tip" : "Send Tip"
      return
    }

    if (isSuperAdminPreview) {
      statusDiv.innerHTML = '<div class="alert alert-success">🍕 Test tip sent! Your voice message will play on the stream shortly.</div>'
      form.reset()
      updateMessageLimit()
      submitBtn.disabled = false
      submitBtn.textContent = "Send Test Tip"
      mountPaymentElement(currentAmount)
    } else {
      // Confirm payment with Stripe
      const { error } = await stripe.confirmPayment({
        elements,
        confirmParams: {
          return_url: window.location.href,
          payment_method_data: {
            billing_details: { name: tipperName }
          }
        },
        redirect: "if_required"
      })

      if (error) {
        errorsDiv.textContent = error.message
        submitBtn.disabled = false
        submitBtn.textContent = "Send Tip"
      } else {
        statusDiv.innerHTML = '<div class="alert alert-success">🍕 Tip sent! Your voice message will play on the stream shortly.</div>'
        form.reset()
        updateMessageLimit()
        submitBtn.disabled = false
        submitBtn.textContent = "Send Tip"
        mountPaymentElement(currentAmount)
      }
    }
  })
}
